import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { GET_CREDENTIALS } from "../redux/actions/actions";
import { jwtDecode } from "jwt-decode";

const useManteinSession = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            try {
                const decodedToken = jwtDecode(token);
                if (decodedToken.exp * 1000 > Date.now()) {
                    dispatch({
                        type: GET_CREDENTIALS,
                        payload: { token, ...decodedToken }
                    });
                } else {
                    localStorage.removeItem("token");
                    return;
                }
            } catch (error) {
                localStorage.removeItem("token");
                return;
            }
        }
    }, [dispatch]);
}

export default useManteinSession;